import React from "react";

const ShipperAddress = (props) => {
  return (
    <div className="SmallText card animated flex-fill">
      <div className="card-body">
        {props.shipperAddress.name ? (
          <>
            <span>{props.shipperAddress.name}</span> <br />
          </>
        ) : null}

        {props.shipperAddress.address.line1 ? (
          <>
            <span>{props.shipperAddress.address.line1}</span> <br />
          </>
        ) : null}
        {props.shipperAddress.address.line2 ? (
          <>
            <span>{props.shipperAddress.address.line2}</span> <br />
          </>
        ) : null}
        {props.shipperAddress.address.city &&
        props.shipperAddress.address.state &&
        props.shipperAddress.address.zip ? (
          <>
            <span>{props.shipperAddress.address.city}</span>,{" "}
            <span>{props.shipperAddress.address.state}</span>{" "}
            <span>{props.shipperAddress.address.zip}</span>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ShipperAddress;
